export async function getTemplateForUser({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.templates.getTemplateForUser();
  if (!errResponse && responseData.success) {
    return commit('setTemplates', responseData.data);
  }

  return Promise.resolve();
}

export async function getLsTemplates({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.templates.getLsTemplates();
  if (!errResponse && responseData.success) {
    return commit('setLsTemplates', responseData.data);
  }

  return [];
}

export async function getRandomLsTemplates({commit}, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.templates.getRandomLsTemplates(payload);
  if (!errResponse && responseData.success) {
    return commit('setLsTemplates', responseData.data);
  }

  return [];
}

export async function updateCompanyModalPriority({commit}, payload) {
  const response = await this.$frontendRepositories.templates.updateCompanyModalPriority(payload);
  return response;
}

export async function getDetail(_, id) {
  return this.$frontendRepositories.templates.getDetail(id)
}

export async function create({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.templates.create(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function deleteTemplate({commit}, id) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.templates.delete(id);
  commit('removeTemplateById', id);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function update({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.templates.update(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function createProposal({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.templates.createProposal(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function search({commit}, payload) {
  commit('showPageLoading', payload, {root: true});

  const response = await this.$frontendRepositories.templates.search(payload);

  const {errResponse, data: responseData} = response;
  if (!errResponse && responseData.success) {
    if (payload.createdByLs) {
      commit('setLsTemplates', responseData.data);
    } else {
      commit('setTemplates', responseData.data);
    }
  }

  commit('hidePageLoading', payload, {root: true});

  return response;
}
